import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchCurrentUserProfile, logout } from './store/slices/authSlice';
import { setAuthToken } from './config/axiosInstance';

const useAuthMiddleware = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const authState = useSelector((state) => state.auth);
  const authToken = localStorage.getItem('authToken');

  useEffect(() => {
    const verifyUser = async () => {
      if (authState.user) {
        setLoading(false);
        return;
      }

      if (!authToken) {
        dispatch(logout());
        navigate('/auth/login');
        return setLoading(false);
      }

      setAuthToken(authToken);

      try {
        const response = await dispatch(fetchCurrentUserProfile(authToken)).unwrap();
        if (!response?.id) {
          dispatch(logout());
          navigate('/auth/login');
        }
      } catch {
        dispatch(logout());
        navigate('/auth/login');
      } finally {
        setLoading(false);
      }
    };

    verifyUser();
  }, [authState.user, authToken, dispatch, navigate]);

  return { loading };
};

export default useAuthMiddleware;
